<template>
    <el-card shadow="never">
        <div>
            <el-row class="box-wrapper">
                <el-col :span="3" class="left-wrapper">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo">
                        <el-menu-item :index="item.id" v-for="(item, index) in menuList" :key="index">
                            <template #title>{{item.name}}</template>
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="21" class="right-wrapper">
                    <div class="ele-pro-table">
                        <div class="ele-table-tool ele-table-tool-default" style="margin-bottom: 20px;">
                            <div class="ele-table-tool-title ele-cell">
                                <div class="ele-cell-content">
                                    <el-button class="text-sm" type="primary" size="small" @click="add"><el-icon class="el-icon-plus"></el-icon><span>添加</span></el-button>
                                </div>
                            </div>
                        </div>
                        <el-table :data="lists" border style="width: 100%">
                            <el-table-column prop="page_id" label="ID" width="100" />
                            <el-table-column prop="page_name" label="模板名称">
                                <template #default="{row, index}">
                                    {{row.page_name}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="create_time" label="创建时间" width="180" />
                            <el-table-column label="操作" align="center" width="300">
                                <template #default="{row, index}">
                                    <el-button size="small" link type="primary" @click="edit(row)">
                                        <el-icon class="el-icon-edit"></el-icon><span>修改</span>
                                    </el-button>
                                    <el-button size="small" link type="primary" v-if="row.page_type != 10" @click="setPageType(row)">
                                        <el-icon class="el-icon-edit"></el-icon><span>设为首页</span>
                                    </el-button>
                                    <el-button size="small" v-if="row.page_type != 10" link type="normal" @click="del(row)">
                                        <el-icon class="el-icon-delete"></el-icon><span>删除</span>
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :current-page="formItem.page"
                            :page-size="formItem.limit"
                            :total="total"
                            :background="true"
                            goto="'前往'"
                            @current-change="pageCurrentChange"
                            class="ele-pagination-circle"/>
                    </div>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
    export default {
        name: "index",
        data () {
            return {
                lists: [
                ],
                loading: false,
                total: 0,
                formItem: {
                    page: 1,
                    limit: 15
                },
                menuList: [
                    {
                        name: '商城首页',
                        id: "1"
                    },
                ],
            }
        },
        created() {
            this.getList()
        },
        methods: {
            reset: function () {
                this.formItem = {
                    page: this.formItem.page,
                    limit: 15
                }
            },
            query: function () {
                this.getList();
            },
            pageCurrentChange(val) {
                this.formItem.page = val
                this.getList()
            },
            // 列表
            getList () {
                var _this = this
                this.loading = true;
                this.axios.post('/store/diy/list', this.formItem).then(function (res) {
                    if (res.code == 1) {
                        let data = res.data.list
                        _this.lists = data.data
                        _this.total = data.total
                        _this.loading = false;
                    }
                })
            },
            add: function () {
                this.$router.push({
                    path: '/page/diy.html'
                })
            },
            edit: function (row) {
                this.$router.push({
                    path: '/page/diy.html',
                    query: {
                        id: row.page_id
                    }
                })
            },
            setPageType: function (row) {
                var _this = this
                this.axios.post('/store/diy/setPageType',{
                    page_id: row.page_id
                }).then(function (res) {
                    if (res.code == 1) {
                        _this.$message.success(res.msg)
                        _this.getList()
                    }
                })
            },
            del: function (row) {
                var _this = this
                this.axios.post('/store/diy/delete',{
                    page_id: row.page_id
                }).then(function (res) {
                    if (res.code == 1) {
                        _this.$message.success(res.msg)
                        _this.getList()
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .box-wrapper{
        .left-wrapper{
            background: #fff;
            border-right: 1px solid #dcdee2;
        }
    }

</style>
